import { render, staticRenderFns } from "./new-ways-to-have-fun-this-family-day-in-pickering.vue?vue&type=template&id=7c39f549&scoped=true&"
import script from "./new-ways-to-have-fun-this-family-day-in-pickering.vue?vue&type=script&lang=js&"
export * from "./new-ways-to-have-fun-this-family-day-in-pickering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39f549",
  null
  
)

export default component.exports